import {createReducer, on} from '@ngrx/store';
import * as AllInstanceTypesActions from '../actions/all-instance-types.actions';
import {ClusterInstanceTypeRecord} from '../../../services/api/vocabulary/cluster/instance-types/cluster.instance-type.vocabulary.model';

export const allInstanceTypesFeatureKey = 'allInstanceTypes';

export interface State {
  record: ClusterInstanceTypeRecord[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(AllInstanceTypesActions.loadAllInstanceTypes, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(AllInstanceTypesActions.loadAllInstanceTypesSuccess, (_state: State, action: {data: ClusterInstanceTypeRecord[]}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(AllInstanceTypesActions.loadAllInstanceTypesFailure, (_state: State, action: {error: unknown}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(AllInstanceTypesActions.clearAllInstanceTypesState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);
